export default {
    DELETE_REFERENCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this reference?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_EXPERIENCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this experience?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_CONTACT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this contact?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_EDUCATION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this education?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_CHILDREN_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this child?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PET_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this pet?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this booking?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PROFILE_BUILDER_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the profile builder {0}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this request?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this job?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_APPLICATION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this application?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_DOCUMENT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the document {0}?',
        ACCEPT_LABEL: 'Delete Document',
        REJECT_LABEL: 'Close'
    },
    DELETE_FILE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the file?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Close'
    },
    DELETE_TEMPLATE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the {0} template {1}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PRICE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the {0} {1}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_USER_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Are you sure you want to delete this user?</h3>
        <p>{0} {1}</p>
        <p>{2}</p>`,
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_ADMIN_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Are you sure you want to delete this user?</h3>
        <p>{0}</p>`,
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_RESOURCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to remove {0}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    CANCEL_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to cancel this booking?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    CANCEL_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to close? Any changes will be lost.',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    EDIT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure of your changes?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    BULK_STATUS_CHANGE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to change the status of the {0} selected users? Their status will be changed to {1}.',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    OVERWRITE_VIDEO_CONFIRM_DIALOG: {
        MESSAGE: 'There is a recorded video. If you record new video, the existed video will be overwritten. Are you sure to continue?',
        ACCEPT_LABEL: 'Continue',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PROFILE_PICTURE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the profile picture?',
        ACCEPT_LABEL: 'Delete Picture',
        REJECT_LABEL: 'Close'
    },
    DELETE_RELATIONSHIP_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to remove the link between {0} and this client?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    CANDIDATE_ACCEPT_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'You are committing to filling this job, are you sure?',
        ACCEPT_LABEL: 'Accept Job',
        REJECT_LABEL: 'Close'
    },
    MARK_AS_FAVORITE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to mark {0} as favorite?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    MARK_AS_DO_NOT_WANT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you do not want {0} again?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    DELETE_NOTE_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Are you sure you want to delete the note?</h3>
        <p style="white-space: pre-wrap;">{0}</p>`,
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_CREDIT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this credit?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    }
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/confirm-dialog/de.js